import { graphql } from '@/gql'

export const ContractFragment = graphql(`
  fragment ContractDetailsContractFields on Contract {
    id
    status
    jobName
    jobDescription
    startDate
    endDate
    purchaseOrderNumber
    rateType
    rate
    currency
    locationPreference
    paymentTermMethod
    paymentTerm
    pdfUrl
    companyCvr
    location {
      formattedAddress
    }
    worker {
      name
    }
  }
`)

export const HireFragment = graphql(`
  fragment ContractDetailsHireFields on Hire {
    id
    number
    hasMilestones
    activeStatus
    contractTypeShort
    recruiterManagesWorkers
    activeContract {
      ...ContractDetailsContractFields
    }
    latestContract {
      ...ContractDetailsContractFields
    }
    job {
      name
      description
      completed
    }
    company {
      name
      address {
        formattedAddress
      }
    }
    paymentRequests {
      paginatorInfo {
        total
      }
    }
    conversation {
      url
      closedAt
      viewerCanAccess
    }
  }
`)
